module.exports = __webpack_public_path__ + "static/media/742MeldrumStNW_2018-06-18_124.9cd1b3d5.jpg";